import { render, staticRenderFns } from "./CustomerInfoForm.vue?vue&type=template&id=940808bc&"
import script from "./CustomerInfoForm.vue?vue&type=script&lang=js&"
export * from "./CustomerInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports